import { customEvent } from "goi_common";
import { ArrowRightIcon } from "@/components/DirectionsIcons";

interface DirectionsCrossLinkProps {
  parlorId: number;
  companyName: string;
}

export const DirectionsCrossLink = ({
  parlorId,
  companyName,
}: DirectionsCrossLinkProps) => {
  return (
    <section className="dr-section" aria-labelledby="dr-cross-title">
      <h2 id="dr-cross-title" className="dr-section__title">
        시설, 빈소, 비용 정보가 궁금하시다면?
      </h2>
      <p className="dr-section__lede">
        {`${companyName}의 빈소 규모, 시설 사용료, 빈소별 가격, 편의시설 상세, 인근 장례식장 비교까지 한 페이지에서 확인하실 수 있습니다.`}
      </p>
      <div className="dr-crosslinks">
        <a
          className="dr-crosslink"
          href={`/place/${parlorId}/family/main/`}
          onClick={() =>
            customEvent({
              newGtm: {
                path: "prlr_directions",
                trigger_and_target: "btn_to_parlor",
              },
            })
          }
        >
          <span>{`${companyName} 빈소·비용 보기`}</span>
          <ArrowRightIcon size={14} style={{ marginLeft: 6 }} />
        </a>
        <a
          className="dr-crosslink"
          href={`/place/${parlorId}/mubinso/`}
          onClick={() =>
            customEvent({
              newGtm: {
                path: "prlr_directions",
                trigger_and_target: "btn_to_mubinso",
              },
            })
          }
        >
          <span>빈소 없이 진행하면? 무빈소 장례 비용 보기</span>
          <ArrowRightIcon size={14} style={{ marginLeft: 6 }} />
        </a>
      </div>
    </section>
  );
};
